import { Tezaurus as TezaurusGenerated, TezaurusDetailApi } from 'tezaury-frontend-ts-axios';
import { AxiosRequestHeaders } from 'axios';
import { ClientResponse } from '../../model/ClientResponse';
import apiConfiguration from '../configuration/apiConfiguration';
import Tezaurus from '../../model/Tezaurus';
import Uuid from '../../model/Uuid';
import { tezauryPrefixPath } from '../configuration/apiConfigurationConstants';

const client = new TezaurusDetailApi(apiConfiguration(tezauryPrefixPath));

const map = (generated: TezaurusGenerated): Tezaurus => ({
  uuid: generated.uuid,
  nazov: generated.nazov,
});

// eslint-disable-next-line import/prefer-default-export
export const fetchTezaurusDetail = async (
  uuid: Uuid,
  shouldFetch = true,
  options: { headers?: AxiosRequestHeaders } = {},
): Promise<ClientResponse<Tezaurus>> => {
  if (!shouldFetch) {
    return {
      data: null,
      responseCode: 200,
    };
  }
  const {
    data,
    status,
  } = await client.getTezaurusDetail(uuid, options);
  return {
    data: map(data),
    responseCode: status,
  };
};
